import { lazy } from 'react';

import { CloudDiskModule, CloudDiskType } from '@/pages/data-center/smart-storage/cloud-disk/types';
import { lazyNamedImport } from '@/utils/lazyNamedImport';

/** 交付类型列表子路由：自定义配置下单（保留左侧菜单） */
const CreateOrder = lazyNamedImport(() => import('@/pages/order'), 'CreateOrder');

// 制品中心
const SystemImage = lazyNamedImport(() => import('@/pages/data-center/artifact-center/system-images'), 'SystemImage');
const SystemImageCreate = lazy(() => import('@/pages/data-center/artifact-center/system-images/create'));
const SystemImageDetail = lazy(() => import('@/pages/data-center/artifact-center/system-images/detail'));
const SystemImageVersionDetail = lazy(() => import('@/pages/data-center/artifact-center/system-images/version-detail'));
const SystemImageVersionCreate = lazy(() => import('@/pages/data-center/artifact-center/system-images/version-create'));
const Drivers = lazyNamedImport(() => import('@/pages/data-center/artifact-center/drivers'), 'Drivers');
const DriverCreate = lazy(() => import('@/pages/data-center/artifact-center/drivers/create'));
const DriverDetail = lazy(() => import('@/pages/data-center/artifact-center/drivers/detail'));
const DriverVersionDetail = lazy(() => import('@/pages/data-center/artifact-center/drivers/version-detail'));
const DriverVersionCreate = lazy(() => import('@/pages/data-center/artifact-center/drivers/version-create'));
const Runtime = lazyNamedImport(() => import('@/pages/data-center/artifact-center/runtime'), 'Runtime');
const RuntimeCreate = lazy(() => import('@/pages/data-center/artifact-center/runtime/create'));
const RuntimeDetail = lazy(() => import('@/pages/data-center/artifact-center/runtime/detail'));
const RuntimeVersionDetail = lazy(() => import('@/pages/data-center/artifact-center/runtime/version-detail'));
const RuntimeVersionCreate = lazy(() => import('@/pages/data-center/artifact-center/runtime/version-create'));
const Tool = lazyNamedImport(() => import('@/pages/data-center/artifact-center/tool'), 'Tool');
const ToolCreate = lazy(() => import('@/pages/data-center/artifact-center/tool/create'));
const ToolDetail = lazy(() => import('@/pages/data-center/artifact-center/tool/detail'));
const ToolVersionDetail = lazy(() => import('@/pages/data-center/artifact-center/tool/version-detail'));
const ToolVersionCreate = lazy(() => import('@/pages/data-center/artifact-center/tool/version-create'));
const InferenceFramework = lazyNamedImport(() => import('@/pages/data-center/model-center/inference-framework'), 'InferenceFramework');
const InferenceFrameworkCreate = lazy(() => import('@/pages/data-center/model-center/inference-framework/create'));
const InferenceFrameworkDetail = lazy(() => import('@/pages/data-center/model-center/inference-framework/detail'));
const InferenceFrameworkVersionDetail = lazy(() => import('@/pages/data-center/model-center/inference-framework/version-detail'));
const InferenceFrameworkVersionCreate = lazy(() => import('@/pages/data-center/model-center/inference-framework/version-create'));

// 应用中心
const AppInstance = lazyNamedImport(() => import('@/pages/data-center/app-center/app-instance'), 'AppInstance');
const AppInstanceCreate = lazy(() => import('@/pages/data-center/app-center/app-instance/create'));
const AppInstanceDetail = lazy(() => import('@/pages/data-center/app-center/app-instance/details'));

const AiApplications = lazyNamedImport(() => import('@/pages/data-center/app-center/ai-applications'), 'AiApplications');
const AiApplicationsCreate = lazy(() => import('@/pages/data-center/app-center/ai-applications/create'));
const AiApplicationsDetail = lazy(() => import('@/pages/data-center/app-center/ai-applications/detail'));
const AiApplicationsVersionDetail = lazy(() => import('@/pages/data-center/app-center/ai-applications/version-detail'));
const AiApplicationsVersionCreate = lazy(() => import('@/pages/data-center/app-center/ai-applications/version-create'));

const AppPlaza = lazyNamedImport(() => import('@/pages/data-center/app-center/app-plaza'), 'AppPlaza');
const AppPlazaDetail = lazy(() => import('@/pages/data-center/app-center/app-plaza/detail'));
const SkillPlaza = lazyNamedImport(() => import('@/pages/data-center/app-center/skill-plaza'), 'SkillPlaza');
const SkillPlazaDetail = lazy(() => import('@/pages/data-center/app-center/skill-plaza/detail'));

// 模型中心
const ModelRepo = lazyNamedImport(() => import('@/pages/data-center/model-center/model-repos'), 'ModelRepo');
const ModelRepoCreate = lazy(() => import('@/pages/data-center/model-center/model-repos/create'));
const ModelRepoDetail = lazy(() => import('@/pages/data-center/model-center/model-repos/detail'));
const DatasetRepo = lazyNamedImport(() => import('@/pages/data-center/model-center/dataset-repos'), 'DatasetRepo');
const DatasetRepoCreate = lazy(() => import('@/pages/data-center/model-center/dataset-repos/create'));
const DatasetRepoDetail = lazy(() => import('@/pages/data-center/model-center/dataset-repos/detail'));
const ModelPlaza = lazyNamedImport(() => import('@/pages/data-center/model-center/model-plaza'), 'ModelPlaza');
const ModelPlazaDetail = lazy(() => import('@/pages/data-center/model-center/model-plaza/detail'));
const ModelInstance = lazyNamedImport(() => import('@/pages/data-center/model-center/model-instance'), 'ModelInstance');
const ModelInstanceCreate = lazy(() => import('@/pages/data-center/model-center/model-instance/create'));
const ModelInstanceDetail = lazy(() => import('@/pages/data-center/model-center/model-instance/details'));
const ModelInstanceTaskDetail = lazy(() => import('@/pages/data-center/model-center/model-instance/details/task'));
const ModelInstanceGatewayDetail = lazy(() => import('@/pages/data-center/model-center/model-instance/details/gateway'));
const ModelInstanceComponentClusterDetail = lazy(() => import('@/pages/data-center/model-center/model-instance/details/component-cluster'));
const TrainingCluster = lazyNamedImport(() => import('@/pages/data-center/model-center/training-cluster'), 'TrainingCluster');
const TrainingClusterCreate = lazy(() => import('@/pages/data-center/model-center/training-cluster/create'));
const TrainingClusterDetail = lazy(() => import('@/pages/data-center/model-center/training-cluster/detail'));
const TrainingClusterRunningTaskDetail = lazy(() => import('@/pages/data-center/model-center/training-cluster/detail/RunningTaskDetail'));
const TrainingTask = lazyNamedImport(() => import('@/pages/data-center/model-center/training-task'), 'TrainingTask');
const TrainingTaskCreate = lazy(() => import('@/pages/data-center/model-center/training-task/create'));
const TrainingTaskDetail = lazy(() => import('@/pages/data-center/model-center/training-task/detail'));
const TrainingTaskRunningTaskDetail = lazy(() => import('@/pages/data-center/model-center/training-task/detail/RunningTaskDetail'));
const ModelSubscription = lazyNamedImport(() => import('@/pages/data-center/model-center/model-subscription'), 'ModelSubscription');
const ModelSubscriptionCreate = lazy(() => import('@/pages/data-center/model-center/model-subscription/create'));
const ModelSubscriptionDetail = lazy(() => import('@/pages/data-center/model-center/model-subscription/Detail'));
const LlmGwAuditLog = lazyNamedImport(() => import('@/pages/data-center/model-center/audit-log'), 'LlmGwAuditLog');
const LlmGwAuditLogDetail = lazy(() => import('@/pages/data-center/model-center/audit-log/detail'));
const ModelProviderManagement = lazyNamedImport(
  () => import('@/pages/data-center/model-center/model-provider-management'),
  'ModelProviderManagement',
);
const ModelProviderDetail = lazy(() => import('@/pages/data-center/model-center/model-provider-management/Detail'));
const ModelDesensitization = lazyNamedImport(
  () => import('@/pages/data-center/model-center/model-desensitization'),
  'ModelDesensitization',
);
const ModelDesensitizationCreate = lazy(() => import('@/pages/data-center/model-center/model-desensitization/create'));
const ModelDesensitizationDetail = lazy(() => import('@/pages/data-center/model-center/model-desensitization/detail'));
const ModelDesensitizationHitDetail = lazy(() => import('@/pages/data-center/model-center/model-desensitization/hit-detail'));
const ApiKeyManagement = lazyNamedImport(() => import('@/pages/data-center/model-center/api-key-management'), 'ApiKeyManagement');
const ApiKeyDetail = lazy(() => import('@/pages/data-center/model-center/api-key-management/Detail'));
const ModelSkills = lazyNamedImport(() => import('@/pages/data-center/model-center/skills'), 'Skills');
const SkillCreate = lazy(() => import('@/pages/data-center/model-center/skills/create'));
const SkillDetail = lazy(() => import('@/pages/data-center/model-center/skills/detail'));
const TextModelExperience = lazyNamedImport(() => import('@/pages/data-center/model-center/model-experience'), 'TextModelExperience');
const AudioModelExperience = lazyNamedImport(() => import('@/pages/data-center/model-center/model-experience'), 'AudioModelExperience');
const VisionModelExperience = lazyNamedImport(() => import('@/pages/data-center/model-center/model-experience'), 'VisionModelExperience');
const EmbeddingModelExperience = lazyNamedImport(
  () => import('@/pages/data-center/model-center/model-experience'),
  'EmbeddingModelExperience',
);
const LlmGwOverview = lazyNamedImport(() => import('@/pages/data-center/model-center/overview'), 'LlmGwOverview');

// 网络安全
// EIP
const EipList = lazy(() => import('@/pages/data-center/network-security/eip'));
// 子网/VPC
const VPC = lazyNamedImport(() => import('@/pages/data-center/network-security/vpc'), 'VPC');
const CreateVpc = lazyNamedImport(() => import('@/pages/data-center/network-security/vpc/create'), 'CreateVpc');
// 安全组
const SafeGroup = lazyNamedImport(() => import('@/pages/data-center/network-security/safe-group'), 'SafeGroup');
const SafeGroupCreatePage = lazyNamedImport(() => import('@/pages/data-center/network-security/safe-group/create'), 'SafeGroupCreatePage');
const SafeGroupDetail = lazyNamedImport(
  () => import('@/pages/data-center/network-security/safe-group/detail/safe-group-detail'),
  'SafeGroupDetail',
);

// 智能存储
// 云盘
const CloudDisk = lazyNamedImport(() => import('@/pages/data-center/smart-storage/cloud-disk'), 'CloudDisk');
const CloudDiskDetailPage = lazyNamedImport(() => import('@/pages/data-center/smart-storage/cloud-disk/details'), 'CloudDiskDetailPage');
const CloudDiskCreatePage = lazyNamedImport(
  () => import('@/pages/data-center/smart-storage/cloud-disk/create/cloud-disk-create-page'),
  'CloudDiskCreatePage',
);
// 持久卷
const Pvc = lazyNamedImport(() => import('@/pages/data-center/smart-storage/pvc'), 'Pvc');
const CreatePvc = lazyNamedImport(() => import('@/pages/data-center/smart-storage/pvc/components/Create'), 'CreatePvc');
const PvcDetail = lazyNamedImport(() => import('@/pages/data-center/smart-storage/pvc/Detail'), 'PvcDetail');

// 计算实例/实例管理
// 云主机实例
const InstanceCreate = lazyNamedImport(() => import('@/pages/data-center/instance-management/cloud-host/create'), 'InstanceCreate');
const InstanceDetailIndex = lazyNamedImport(
  () => import('@/pages/data-center/instance-management/cloud-host/detail'),
  'InstanceDetailIndex',
);
const Instance = lazyNamedImport(() => import('@/pages/data-center/instance-management/cloud-host'), 'Instance');
// 容器实例
const ContainerInstance = lazyNamedImport(() => import('@/pages/data-center/instance-management/container'), 'ContainerInstance');
const ContainerInstanceDetail = lazyNamedImport(
  () => import('@/pages/data-center/instance-management/container/details'),
  'ContainerInstanceDetails',
);
const ContainerInstanceCreate = lazyNamedImport(() => import('@/pages/data-center/instance-management/container/create'), 'InstanceCreate');
// 裸金属实例
const BareMetalInstance = lazy(() => import('@/pages/data-center/instance-management/bare-metal'));
const BareMetalInstanceCreate = lazy(() => import('@/pages/data-center/instance-management/bare-metal/add'));
const BareMetalInstanceDetail = lazy(() => import('@/pages/data-center/instance-management/bare-metal/detail'));
// 裸金属弹性实例
const ElasticBareMetal = lazy(() => import('@/pages/data-center/instance-management/elastic-bare-metal'));
const ElasticBareMetalDetail = lazy(() => import('@/pages/data-center/instance-management/elastic-bare-metal/detail'));
const ElasticBareMetalCreate = lazy(() => import('@/pages/data-center/instance-management/elastic-bare-metal/create'));

// 计算集群/集群资产
const ClusterList = lazy(() => import('@/pages/data-center/assets/clusters'));

// 费用中心
/** 订单管理 */
const OrderList = lazy(() => import('@/pages/order/list'));
const OrderDetail = lazy(() => import('@/pages/order/details'));
/** 账单管理 */
const BillList = lazy(() => import('@/pages/data-center/cost-center/bill-management'));
const BillDetail = lazyNamedImport(() => import('@/pages/data-center/cost-center/bill-management/detail'), 'BillDetail');

// 运维中心总览
const OperationOverview = lazy(() => import('@/pages/data-center/alert-center/OperationOverview'));

// 监控分析/监控中心
const MonitorNewDashboard = lazyNamedImport(() => import('@/pages/data-center/monitor-center/LargeScreen/add'), 'MonitorNewDashboard');
const DashboardDetail = lazyNamedImport(() => import('@/pages/data-center/monitor-center/LargeScreen/detail'), 'DashboardDetail');
const MonitorRulesDetail = lazy(() => import('@/pages/data-center/monitor-center/MonitorRule/Detail'));
const EditMonitorRules = lazy(() => import('@/pages/data-center/monitor-center/MonitorRule/Edit'));
const LargeScreenDisplay = lazyNamedImport(() => import('@/pages/data-center/monitor-center/LargeScreen'), 'LargeScreenDisplay');
const LargeScreenConfig = lazyNamedImport(() => import('@/pages/data-center/monitor-center/LargeScreen/Config'), 'LargeScreenConfig');
const MetricQuery = lazy(() => import('@/pages/data-center/monitor-center/MetricQuery'));
const MonitorRule = lazy(() => import('@/pages/data-center/monitor-center/MonitorRule'));
const DataSource = lazy(() => import('@/pages/data-center/monitor-center/DataSource'));

// 日志中心
const EditTables = lazy(() => import('@/pages/data-center/log-center/LogAccess/Edit'));
const EditRules = lazy(() => import('@/pages/data-center/log-center/LogRule/Edit'));
const LogAccess = lazy(() => import('@/pages/data-center/log-center/LogAccess'));
const LogAccessDetail = lazyNamedImport(() => import('@/pages/data-center/log-center/LogAccess/Detail'), 'TableDetail');
const LogRule = lazy(() => import('@/pages/data-center/log-center/LogRule'));
const LogRulesDetail = lazy(() => import('@/pages/data-center/log-center/LogRule/Detail'));

// 告警中心、告警设置、监控/日志告警记录
const AlertLogDetail = lazyNamedImport(() => import('@/pages/data-center/alert-center/LogAlert/Detail'), 'AlertLogDetail');
const Medium = lazyNamedImport(() => import('@/pages/data-center/alert-center/Medium'), 'Medium');
const MediumCreatePage = lazyNamedImport(() => import('@/pages/data-center/alert-center/Medium/create'), 'MediumCreatePage');
const MonitorAlert = lazy(() => import('@/pages/data-center/alert-center/MonitorAlert'));
const AlertMonitorDetail = lazy(() => import('@/pages/data-center/alert-center/MonitorAlert/Detail'));
const LogAlert = lazyNamedImport(() => import('@/pages/data-center/alert-center/LogAlert'), 'LogAlert');

// 安全中心-审计日志
const Audit = lazyNamedImport(() => import('@/pages/system/security-center/audit'), 'Audit');

/** ============================ 路由 ==================================== */

/** 应用中心（DC / 租户共用）：广场 + 应用实例 */
export const appCenter = [
  {
    title: 'app-instance',
    path: '/app-instance',
    element: <AppInstance />,
  },
  {
    title: 'app-instance-create',
    path: '/app-instance/create',
    element: <AppInstanceCreate />,
  },
  {
    title: 'app-instance-create-order',
    path: '/app-instance/create-order',
    element: <CreateOrder />,
  },
  {
    title: 'app-instance-detail',
    path: '/app-instance/:name/namespace/:namespace/detail',
    element: <AppInstanceDetail />,
  },
  {
    title: 'app-plaza-create-order',
    path: '/app-plaza/create-order',
    element: <CreateOrder />,
  },
  {
    title: 'app-plaza-detail',
    path: '/app-plaza/:artifactId/versions/:versionId',
    element: <AppPlazaDetail />,
  },
  {
    title: 'app-plaza',
    path: '/app-plaza',
    element: <AppPlaza />,
  },
  {
    title: 'skill-plaza-detail',
    path: '/skill-plaza/:id',
    element: <SkillPlazaDetail />,
  },
  {
    title: 'skill-plaza',
    path: '/skill-plaza',
    element: <SkillPlaza />,
  },
];

/** 应用中心 DC 专属：应用仓库 / 技能仓库（租户菜单无入口，不注册路由） */
export const appCenterDcOnly = [
  {
    title: 'ai-applications-create',
    path: '/ai-applications/create',
    element: <AiApplicationsCreate />,
  },
  {
    title: 'ai-applications-edit',
    path: '/ai-applications/edit/:id',
    element: <AiApplicationsCreate />,
  },
  {
    title: 'ai-applications-detail',
    path: '/ai-applications/:id',
    element: <AiApplicationsDetail />,
  },
  {
    title: 'ai-applications',
    path: '/ai-applications',
    element: <AiApplications />,
  },
  {
    title: 'ai-applications-version-detail',
    path: '/ai-applications/:artifactId/versions/:versionId',
    element: <AiApplicationsVersionDetail />,
  },
  {
    title: 'ai-applications-version-create',
    path: '/ai-applications/:artifactId/versions/create',
    element: <AiApplicationsVersionCreate />,
  },
  {
    title: 'ai-applications-version-edit',
    path: '/ai-applications/:artifactId/versions/edit/:versionId',
    element: <AiApplicationsVersionCreate />,
  },
  {
    title: 'skills-create',
    path: '/skills/create',
    element: <SkillCreate />,
  },
  {
    title: 'skills-edit',
    path: '/skills/edit/:id',
    element: <SkillCreate />,
  },
  {
    title: 'skills-detail',
    path: '/skills/:id/readme/',
    element: <SkillDetail />,
  },
  {
    title: 'skills',
    path: '/skills',
    element: <ModelSkills />,
  },
];
// 模型体验
export const modelExperience = [
  {
    title: 'text-model-experience',
    path: '/model-center/model-experience/text',
    element: <TextModelExperience />,
  },
  {
    title: 'audio-model-experience',
    path: '/model-center/model-experience/audio',
    element: <AudioModelExperience />,
  },
  {
    title: 'vision-model-experience',
    path: '/model-center/model-experience/vision',
    element: <VisionModelExperience />,
  },
  {
    title: 'embedding-model-experience',
    path: '/model-center/model-experience/embedding',
    element: <EmbeddingModelExperience />,
  },
];

// 模型中心：数据中心与租户共享（不含厂商 / 仓库 / 脱敏）
export const modelCenter = [
  {
    title: 'ai-overview',
    path: '/overview',
    element: <LlmGwOverview />,
  },
  {
    title: 'model-instance',
    path: '/model-center/model-instance',
    element: <ModelInstance />,
  },
  {
    title: 'model-instance-create',
    path: '/model-center/model-instance/create',
    element: <ModelInstanceCreate />,
  },
  {
    title: 'model-instance-create-order',
    path: '/model-center/model-instance/create-order',
    element: <CreateOrder />,
  },
  {
    title: 'model-instance-detail',
    path: '/model-center/model-instance/:name/namespace/:namespace/detail',
    element: <ModelInstanceDetail />,
  },
  {
    title: 'model-instance-component-cluster-detail',
    path: '/model-center/model-instance/:name/namespace/:namespace/component/:component/detail',
    element: <ModelInstanceComponentClusterDetail />,
  },
  {
    title: 'model-instance-taskcluster-detail',
    path: '/model-center/model-instance/:name/namespace/:namespace/taskcluster/:clusterName',
    element: <ModelInstanceTaskDetail />,
  },
  {
    title: 'model-instance-gateway-detail',
    path: '/model-center/model-instance/:name/namespace/:namespace/gateway/:statefulSetName',
    element: <ModelInstanceGatewayDetail />,
  },
  {
    title: 'training-cluster',
    path: '/model-center/training-cluster',
    element: <TrainingCluster />,
  },
  {
    title: 'training-cluster-create',
    path: '/model-center/training-cluster/create',
    element: <TrainingClusterCreate />,
  },
  {
    title: 'training-cluster-create-order',
    path: '/model-center/training-cluster/create-order',
    element: <CreateOrder />,
  },
  {
    title: 'training-cluster-detail',
    path: '/model-center/training-cluster/:name/namespace/:namespace/detail',
    element: <TrainingClusterDetail />,
  },
  {
    title: 'training-cluster-running-task-detail',
    path: '/model-center/training-cluster/:clusterName/namespace/:namespace/task/:taskName/detail',
    element: <TrainingClusterRunningTaskDetail />,
  },
  {
    title: 'training-task',
    path: '/model-center/training-task',
    element: <TrainingTask />,
  },
  {
    title: 'training-task-create',
    path: '/model-center/training-task/create',
    element: <TrainingTaskCreate />,
  },
  {
    title: 'training-task-detail',
    path: '/model-center/training-task/:id/detail',
    element: <TrainingTaskDetail />,
  },
  {
    title: 'training-task-running-task-detail',
    path: '/model-center/training-task/:trainingTaskName/namespace/:namespace/task/:taskName/detail',
    element: <TrainingTaskRunningTaskDetail />,
  },
  {
    title: 'model-plaza-create-order',
    path: '/model-center/model-plaza/create-order',
    element: <CreateOrder />,
  },
  {
    title: 'model-plaza-detail',
    path: '/model-center/model-plaza/:id/readme/',
    element: <ModelPlazaDetail />,
  },
  {
    title: 'model-plaza',
    path: '/model-center/model-plaza',
    element: <ModelPlaza />,
  },
  {
    title: 'model-subscription',
    path: '/model-center/model-subscription',
    element: <ModelSubscription />,
  },
  {
    title: 'model-subscription-create',
    path: '/model-center/model-subscription/create',
    element: <ModelSubscriptionCreate />,
  },
  {
    title: 'model-subscription-create-order',
    path: '/model-center/model-subscription/create-order',
    element: <CreateOrder />,
  },
  {
    title: 'model-subscription-edit',
    path: '/model-center/model-subscription/edit/:id',
    element: <ModelSubscriptionCreate />,
  },
  {
    title: 'model-subscription-detail',
    path: '/model-center/model-subscription/:id',
    element: <ModelSubscriptionDetail />,
  },
  {
    title: 'model-audit-log',
    path: '/model-center/audit-log',
    element: <LlmGwAuditLog />,
  },
  {
    title: 'model-audit-log-detail',
    path: '/model-center/audit-log/:uuid',
    element: <LlmGwAuditLogDetail />,
  },
  {
    title: 'inference-framework-create',
    path: '/model-center/inference-framework/create',
    element: <InferenceFrameworkCreate />,
  },
  {
    title: 'inference-framework-edit',
    path: '/model-center/inference-framework/edit/:id',
    element: <InferenceFrameworkCreate />,
  },
  {
    title: 'inference-framework-detail',
    path: '/model-center/inference-framework/:id',
    element: <InferenceFrameworkDetail />,
  },
  {
    title: 'inference-framework',
    path: '/model-center/inference-framework',
    element: <InferenceFramework />,
  },
  {
    title: 'inference-framework-version-detail',
    path: '/model-center/inference-framework/:artifactId/versions/:versionId',
    element: <InferenceFrameworkVersionDetail />,
  },
  {
    title: 'inference-framework-version-create',
    path: '/model-center/inference-framework/:artifactId/versions/create',
    element: <InferenceFrameworkVersionCreate />,
  },
  {
    title: 'inference-framework-version-edit',
    path: '/model-center/inference-framework/:artifactId/versions/edit/:versionId',
    element: <InferenceFrameworkVersionCreate />,
  },
];

/** 模型中心 DC 专属：模型仓库、数据集仓库、厂商管理、脱敏（租户不注册路由） */
export const modelCenterDcOnly = [
  {
    title: 'dataset-repos-create',
    path: '/model-center/dataset-repos/create',
    element: <DatasetRepoCreate />,
  },
  {
    title: 'dataset-repos-edit',
    path: '/model-center/dataset-repos/edit/:id',
    element: <DatasetRepoCreate />,
  },
  {
    title: 'dataset-repos-detail',
    path: '/model-center/dataset-repos/:id/readme/',
    element: <DatasetRepoDetail />,
  },
  {
    title: 'dataset-repos',
    path: '/model-center/dataset-repos',
    element: <DatasetRepo />,
  },
  {
    title: 'model-repos-create',
    path: '/model-center/model-repos/create',
    element: <ModelRepoCreate />,
  },
  {
    title: 'model-repos-edit',
    path: '/model-center/model-repos/edit/:id',
    element: <ModelRepoCreate />,
  },
  {
    title: 'model-repos-detail',
    path: '/model-center/model-repos/:id/readme/',
    element: <ModelRepoDetail />,
  },
  {
    title: 'model-repos',
    path: '/model-center/model-repos',
    element: <ModelRepo />,
  },
  {
    title: 'model-provider-management',
    path: '/model-center/model-provider',
    element: <ModelProviderManagement />,
  },
  {
    title: 'model-provider-detail',
    path: '/model-center/model-provider/:id',
    element: <ModelProviderDetail />,
  },
  {
    title: 'model-desensitization',
    path: '/model-center/model-desensitization',
    element: <ModelDesensitization />,
  },
  {
    title: 'model-desensitization-create',
    path: '/model-center/model-desensitization/create',
    element: <ModelDesensitizationCreate />,
  },
  {
    title: 'model-desensitization-edit',
    path: '/model-center/model-desensitization/edit/:id',
    element: <ModelDesensitizationCreate />,
  },
  {
    title: 'model-desensitization-detail',
    path: '/model-center/model-desensitization/detail/:id',
    element: <ModelDesensitizationDetail />,
  },
  {
    title: 'model-desensitization-hit-detail',
    path: '/model-center/model-desensitization/detail/:id/hits/:hitId',
    element: <ModelDesensitizationHitDetail />,
  },
];

/** AI 与应用中心共用的固定 API Key 页面。 */
export const apiKeyManagement = [
  {
    title: 'api-key-management',
    path: '/model-center/api-key',
    element: <ApiKeyManagement />,
  },
  {
    title: 'api-key-detail',
    path: '/model-center/api-key/:id',
    element: <ApiKeyDetail />,
  },
];

/** 租户 AI 中心：不含厂商 / 仓库 / 脱敏 */
export const aiCenter = [...modelExperience, ...modelCenter, ...apiKeyManagement];
/** 数据中心 AI 中心：含 DC 专属治理页 */
export const aiCenterDc = [...aiCenter, ...modelCenterDcOnly];

// 制品中心
export const artifactCenter = [
  {
    title: 'system-images-create',
    path: '/system-images/create',
    element: <SystemImageCreate />,
  },
  {
    title: 'system-images-edit',
    path: '/system-images/edit/:id',
    element: <SystemImageCreate />,
  },
  {
    title: 'system-images-detail',
    path: '/system-images/:id',
    element: <SystemImageDetail />,
  },
  {
    title: 'system-images',
    path: '/system-images',
    element: <SystemImage />,
  },
  {
    title: 'system-images-version-detail',
    path: '/system-images/:artifactId/versions/:versionId',
    element: <SystemImageVersionDetail />,
  },
  {
    title: 'system-images-version-create',
    path: '/system-images/:artifactId/versions/create',
    element: <SystemImageVersionCreate />,
  },
  {
    title: 'system-images-version-edit',
    path: '/system-images/:artifactId/versions/edit/:versionId',
    element: <SystemImageVersionCreate />,
  },
  {
    title: 'drivers-create',
    path: '/drivers/create',
    element: <DriverCreate />,
  },
  {
    title: 'drivers-edit',
    path: '/drivers/edit/:id',
    element: <DriverCreate />,
  },
  {
    title: 'drivers-detail',
    path: '/drivers/:id',
    element: <DriverDetail />,
  },
  {
    title: 'drivers',
    path: '/drivers',
    element: <Drivers />,
  },
  {
    title: 'drivers-version-detail',
    path: '/drivers/:artifactId/versions/:versionId',
    element: <DriverVersionDetail />,
  },
  {
    title: 'drivers-version-create',
    path: '/drivers/:artifactId/versions/create',
    element: <DriverVersionCreate />,
  },
  {
    title: 'drivers-version-edit',
    path: '/drivers/:artifactId/versions/edit/:versionId',
    element: <DriverVersionCreate />,
  },
  {
    title: 'runtime-create',
    path: '/runtime/create',
    element: <RuntimeCreate />,
  },
  {
    title: 'runtime-edit',
    path: '/runtime/edit/:id',
    element: <RuntimeCreate />,
  },
  {
    title: 'runtime-detail',
    path: '/runtime/:id',
    element: <RuntimeDetail />,
  },
  {
    title: 'runtime',
    path: '/runtime',
    element: <Runtime />,
  },
  {
    title: 'runtime-version-detail',
    path: '/runtime/:artifactId/versions/:versionId',
    element: <RuntimeVersionDetail />,
  },
  {
    title: 'runtime-version-create',
    path: '/runtime/:artifactId/versions/create',
    element: <RuntimeVersionCreate />,
  },
  {
    title: 'runtime-version-edit',
    path: '/runtime/:artifactId/versions/edit/:versionId',
    element: <RuntimeVersionCreate />,
  },
  {
    title: 'tool-create',
    path: '/tool/create',
    element: <ToolCreate />,
  },
  {
    title: 'tool-edit',
    path: '/tool/edit/:id',
    element: <ToolCreate />,
  },
  {
    title: 'tool-detail',
    path: '/tool/:id',
    element: <ToolDetail />,
  },
  {
    title: 'tool',
    path: '/tool',
    element: <Tool />,
  },
  {
    title: 'tool-version-detail',
    path: '/tool/:artifactId/versions/:versionId',
    element: <ToolVersionDetail />,
  },
  {
    title: 'tool-version-create',
    path: '/tool/:artifactId/versions/create',
    element: <ToolVersionCreate />,
  },
  {
    title: 'tool-version-edit',
    path: '/tool/:artifactId/versions/edit/:versionId',
    element: <ToolVersionCreate />,
  },
];

// 网络安全
export const networkSecurity = [
  {
    path: '/eip',
    element: <EipList />,
  },
  {
    path: '/vpc',
    element: <VPC />,
  },
  {
    path: '/vpc/create',
    element: <CreateVpc />,
  },
  {
    path: '/safegroup',
    element: <SafeGroup />,
  },
  {
    path: '/safegroup/create',
    element: <SafeGroupCreatePage />,
  },
  {
    path: '/safegroup/edit/:sg',
    element: <SafeGroupCreatePage />,
  },
  {
    path: '/safegroup/detail/:sg',
    element: <SafeGroupDetail />,
  },
];

// 智能存储
export const intelligentStorage = [
  {
    path: '/vm/cloud-disk',
    element: <CloudDisk type={CloudDiskType.CLOUD_HOST} module={CloudDiskModule.PLATFORM} />,
  },
  {
    path: '/vm/cloud-disk/create',
    element: <CloudDiskCreatePage type={CloudDiskType.CLOUD_HOST} module={CloudDiskModule.PLATFORM} />,
  },
  {
    path: '/vm/cloud-disk/detail/:id',
    element: <CloudDiskDetailPage type={CloudDiskType.CLOUD_HOST} module={CloudDiskModule.PLATFORM} />,
  },
  {
    title: 'pvcs',
    path: '/pvcs',
    element: <Pvc />,
  },
  {
    title: 'create-pvc',
    path: '/pvcs/create',
    element: <CreatePvc />,
  },
  {
    title: 'pvc-detail',
    path: '/pvcs/:pvc/detail',
    element: <PvcDetail />,
  },
];

// 计算实例/实例管理
export const instanceManagement = [
  {
    path: '/container/instance',
    element: <ContainerInstance />,
  },
  {
    path: '/container/instance/create',
    element: <ContainerInstanceCreate />,
  },
  {
    path: '/container/instance/create-order',
    element: <CreateOrder />,
  },
  {
    path: '/container/instance/:instance/namespace/:namespace/detail',
    element: <ContainerInstanceDetail />,
  },
  {
    path: '/cloud/instance',
    element: <Instance />,
  },
  {
    path: '/cloud/instance/create',
    element: <InstanceCreate />,
  },
  {
    path: '/cloud/instance/create-order',
    element: <CreateOrder />,
  },
  {
    path: '/cloud/instance/:instance/namespace/:namespace/detail',
    element: <InstanceDetailIndex />,
  },
  {
    title: 'instance',
    path: '/bare-metal/instance',
    element: <BareMetalInstance />,
  },
  {
    path: '/bare-metal/instance/create',
    element: <BareMetalInstanceCreate />,
  },
  {
    path: '/bare-metal/instance/create-order',
    element: <CreateOrder />,
  },
  {
    path: '/bare-metal/instance/edit/:id',
    element: <BareMetalInstanceCreate />,
  },
  {
    path: '/bare-metal/instance/detail/:id',
    element: <BareMetalInstanceDetail />,
  },
  {
    path: '/ebm/instance',
    element: <ElasticBareMetal />,
  },
  {
    path: '/ebm/instance/create',
    element: <ElasticBareMetalCreate />,
  },
  {
    path: '/ebm/instance/create-order',
    element: <CreateOrder />,
  },
  {
    path: '/ebm/instance/:id/namespace/:namespace/detail',
    element: <ElasticBareMetalDetail />,
  },
];

// 费用中心
export const costCenter = [
  {
    title: 'orderList',
    path: '/orders',
    element: <OrderList />,
  },
  {
    title: 'orderDetail',
    path: '/orders/:id',
    element: <OrderDetail />,
  },
  {
    title: 'orderBillDetail',
    path: '/orders/:orderId/bills/:id',
    element: <BillDetail />,
  },
  {
    title: 'billList',
    path: '/bills',
    element: <BillList />,
  },
  {
    title: 'billDetail',
    path: '/bills/:id',
    element: <BillDetail />,
  },
];

// 运维中心总览
export const operationOverview = [
  {
    title: 'opsOverview',
    path: '/overview',
    element: <OperationOverview />,
  },
];

// 监控中心
export const monitorCenter = [
  {
    path: '/monitor-center/largescreen-display',
    element: <LargeScreenDisplay />,
  },
  {
    title: 'largescreen-config',
    path: '/monitor-center/largescreen-config',
    element: <LargeScreenConfig />,
  },
  {
    title: 'metric-query',
    path: '/monitor-center/metric-query',
    element: <MetricQuery />,
  },
  {
    title: 'rule-configuration',
    path: '/monitor-center/rule-configuration',
    element: <MonitorRule />,
  },
  {
    title: 'data-access',
    path: '/monitor-center/data-access',
    element: <DataSource />,
  },
  {
    title: 'new-dashboard',
    path: '/monitor-center/largescreen-config/new-dashboard',
    element: <MonitorNewDashboard />,
  },
  {
    title: 'dashboard-detail',
    path: '/monitor-center/largescreen-config/dashboard-detail/:dashboard',
    element: <DashboardDetail />,
  },
  {
    title: 'rule-add',
    path: '/monitor-center/rule-configuration/rule-add',
    element: <EditMonitorRules />,
  },
  {
    title: 'rule-edit',
    path: '/monitor-center/rule-configuration/rule-edit/:id',
    element: <EditMonitorRules />,
  },
  {
    title: 'rule-detail',
    path: '/monitor-center/rule-configuration/rule-detail/:id',
    element: <MonitorRulesDetail />,
  },
];

// 日志中心
export const logCenter = [
  {
    title: 'log-access',
    path: '/log-center/log-access',
    element: <LogAccess />,
  },
  {
    title: 'log-rule',
    path: '/log-center/log-rule',
    element: <LogRule />,
  },
  {
    title: 'add-logtable',
    path: '/log-center/log-access/add',
    element: <EditTables />,
  },
  {
    title: 'edit-logtable',
    path: '/log-center/log-access/edit/:table/:id',
    element: <EditTables />,
  },
  {
    title: 'logtable-detail',
    path: '/log-center/log-access/detail/:table/:id',
    element: <LogAccessDetail />,
  },
  {
    title: 'add-logrule',
    path: '/log-center/log-rule/rule-add',
    element: <EditRules />,
  },
  {
    title: 'edit-logrule',
    path: '/log-center/log-rule/rule-edit/:id',
    element: <EditRules />,
  },
  {
    title: 'logrule-detail',
    path: '/log-center/log-rule/rule-detail/:id',
    element: <LogRulesDetail />,
  },
];

// 告警中心/告警设置
export const alertCenter = [
  {
    title: 'alert-monitor',
    path: '/alert-center/alert-monitor',
    element: <MonitorAlert />,
  },
  {
    title: 'alert-log',
    path: '/alert-center/alert-log',
    element: <LogAlert />,
  },
  {
    title: 'alert-medium',
    path: '/alert-center/alert-medium',
    element: <Medium />,
  },
  {
    title: 'alert-medium-create',
    path: '/alert-center/alert-medium/create',
    element: <MediumCreatePage />,
  },
  {
    title: 'alert-medium-edit',
    path: '/alert-center/alert-medium/edit/:id',
    element: <MediumCreatePage />,
  },
  {
    title: 'alertmonitor-detail',
    path: '/alert-center/alert-monitor/alertmonitor-detail/:alertable/:id',
    element: <AlertMonitorDetail />,
  },
  {
    title: 'alertlog-detail',
    path: '/alert-center/alert-log/alertlog-detail/:alertable/:id',
    element: <AlertLogDetail />,
  },
];

// 安全中心-审计日志
export const auditLog = [
  {
    title: 'audit',
    path: '/audit',
    element: <Audit />,
  },
];

// 计算集群/集群资产
export const clusterAsset = [
  {
    title: 'clusterList',
    path: '/clusters/biz',
    element: <ClusterList />,
  },
];
